/**
 * Caracteres used to evaluate a regex need to be escaped from the given string
 * Ref: https://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
 */
export function escapeRegExp(str: string) {
  return str.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
}

/** Match ALL words in ANY order or ANY casing */
export const queryRegExp = (query: string) => (
  new RegExp(`${query.split(' ').map((s) => `(?=.*${escapeRegExp(s.trim())})`).join('')}`, 'ig')
);

/**
 * Remove all trailing zeros from a given string
 * Ref: https://stackoverflow.com/a/37828637
 */
export const trailingZerosRegExp = /^(-?\d+)(?:\.0+|(\.\d*?)0+|\.+)?$/g;

/** Ref: https://stackoverflow.com/a/3143231 */
 
export const dateISORegExp = /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/;
